import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, inject, input, output, viewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromStore from "../store";
import {LoginService} from "../../../../main/auth/login/login.service";
import {Chat, ChatParticipante, ComponenteDigital} from "@cdk/models";
import { ImageCropperComponent, ImageCropperModule } from "ngx-image-cropper";
import { ChatMensagemHeaderComponent } from '../chat-mensagem-header/chat-mensagem-header.component';

import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/form-field';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { SafeResourceUrlPipe } from '../../../../../@cdk/pipes/safe-resource-url.pipe';
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
    selector: 'chat-grupo-form',
    templateUrl: './chat-grupo-form.component.html',
    styleUrls: ['./chat-grupo-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [ChatMensagemHeaderComponent, FormsModule, ReactiveFormsModule, MatIconButton, MatIcon, MatFormField, MatLabel, MatInput, MatHint, CdkTextareaAutosize, MatError, MatButton, MatProgressSpinner, ImageCropperModule, SafeResourceUrlPipe]
})
export class ChatGrupoFormComponent implements OnChanges, OnInit, AfterViewInit
{
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _formBuilder = inject(FormBuilder);
    private _store = inject<Store<fromStore.ChatAppState>>(Store);
    private _loginService = inject(LoginService);


    readonly cancelFormHandler = output();

    readonly imagemCapaCroppedHandler = output<ComponenteDigital>();

    readonly saveHandler = output<Chat>();

    readonly chatFormHandler = output<Chat>();

    readonly chatParticipantesHandler = output<Chat>();

    readonly removerParticipanteHandler = output<ChatParticipante>();

    readonly excluirChatHandler = output<Chat>();

    readonly chat = input<Chat>(new Chat());

    @Input()
    capa: ComponenteDigital = new ComponenteDigital();

    @Input()
    errors: any = null;

    readonly saving = input<boolean>(false);

    @Input()
    activeCard: string = 'form';

    readonly imgCapaUpload = viewChild<ElementRef>('imgCapaUpload');

    readonly imgCapaCropComponent = viewChild<ImageCropperComponent>('imgCapaCropComponent');

    chatGrupoForm: FormGroup;
    imagemCapaEvent: any = '';
    uploadImagesMimeTypes: string = 'image/pjpeg,image/jpeg';



    constructor()
    {
        this.chatGrupoForm = this._formBuilder.group({
            id: [null],
            nome: [null, [Validators.required]],
            descricao: [null],
            capa: [null],

        });
    }

    salvarChatGrupo(): void
    {
        if (!this.chatGrupoForm.invalid) {
            const chat = new Chat();
            Object.entries(this.chatGrupoForm.value).forEach(([key, value]) => {
                chat[key] = value;
            });
            chat.grupo = true;
            chat.ativo = true;
            this.saveHandler.emit(chat);
        }
    }

    cancelForm(): void
    {
        this.chatGrupoForm.reset();
        this.cancelFormHandler.emit();
    }


    uploadImagemCapa(): void
    {
        this.imgCapaUpload().nativeElement.click();
    }

    changeImgCapaUpload(event): void
    {
        this.errors = null;
        const uploadFileInput = this.imgCapaUpload().nativeElement;
        if (uploadFileInput.files.length) {
            const file = uploadFileInput.files[0];
            if (!this.uploadImagesMimeTypes.split(',').includes(file.type)) {

                this.chatGrupoForm.setErrors({
                    rulesError: 'Apenas extensões jpeg e jpg são permitidas para upload de imagem.'
                });

                this._changeDetectorRef.markForCheck();
                return;
            }
            this.imagemCapaEvent = event;
            this.activeCard = 'crop-imagem-capa';
        }
    }

    imagemCapaCropped(event: any): void
    {
        const componenteDigital = new ComponenteDigital();
        componenteDigital.conteudo = event.base64;
        componenteDigital.mimetype = event.base64.split(',')[0].split(':')[1].split(';')[0];
        componenteDigital.fileName = 'imagem_perfil.jpeg';
        componenteDigital.tamanho = event.base64.length;

        this.imagemCapaCroppedHandler.emit(componenteDigital);
    }

    cropImgCapa(): void
    {
        this.imgCapaCropComponent().crop();
        this.cancelCrop();
    }

    cancelCrop(): void
    {
        this.imagemCapaEvent = '';
        this.activeCard = 'form';
        this._changeDetectorRef.markForCheck();
    }

    chatParticipantes(chat: Chat): void
    {
        this.chatParticipantesHandler.emit(chat);
    }

    chatForm(chat: Chat): void
    {
        this.chatFormHandler.emit(chat);
    }

    removerParticipante(chatParticipante: ChatParticipante): void
    {
        this.removerParticipanteHandler.emit(chatParticipante);
    }

    excluirChat(chat: Chat): void
    {
        this.excluirChatHandler.emit(chat);
    }

    ngOnInit(): void
    {
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (changes['capa']) {
            this.chatGrupoForm.get('capa').setValue(this.capa || null);
        }

        if (changes['chat'] && !this.chatGrupoForm.dirty) {
            const chat = this.chat();
            this.chatGrupoForm.patchValue({
                id: chat?.id,
                nome: chat?.nome,
                descricao: chat?.descricao,
                capa: (this.capa || chat?.capa)
            });

            this.capa = this.capa || chat?.capa;
            this.chatGrupoForm.get('capa').setValue(this.capa || null);
        }

        if (changes['errors']) {
            if (this.errors && this.errors.status && this.errors.status === 422) {
                try {
                    const data = JSON.parse(this.errors.error.message);
                    const fields = Object.keys(data || {});
                    fields.forEach((field) => {
                        const control = this.chatGrupoForm.get(field);
                        control.setErrors({formError: data[field].join(' - ')});
                    });
                } catch (e) {
                    this.chatGrupoForm.setErrors({rulesError: this.errors.error.message});
                }
            }

            if (!this.errors) {
                Object.keys(this.chatGrupoForm.controls).forEach((key) => {
                    this.chatGrupoForm.get(key).setErrors(null);
                });

                this.chatGrupoForm.setErrors(null);
            }
        }

        this._changeDetectorRef.markForCheck();
    }

    ngAfterViewInit(): void {
        if (!this.chat()?.id) {
            this.chatGrupoForm.reset();
        }
    }

}
